import { render } from "./ResourcesSlider.vue?vue&type=template&id=c6149640"
import script from "./ResourcesSlider.vue?vue&type=script&lang=js"
export * from "./ResourcesSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__